import { Skeleton, Table } from "antd";
import React, { FC, useEffect, useState } from "react";
import PageContent from '../../../components/ui/pageContent';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { IGlobalReducerState } from "../../../store/base/interface/IGlobalReducerState";
import { getColumns } from "./CamposApi.helper";
import styles from './CamposApi.module.scss';
import { ConfigActions } from "../../../store/config/Config.actions";

const CamposApi: FC<Props> = (props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(ConfigActions.listCamposApi());
    }, []);

    return (
        <>
            <PageContent title='Lista Campos API' className={styles['container']}>
                {props.isLoading ?
                    <Skeleton active />
                    :
                    <>
                        <Table columns={getColumns(props.camposApi)} dataSource={props.camposApi} style={{ overflowY: 'auto' }} pagination={false} />
                    </>
                }
            </PageContent>
        </>
    );
}

const mapState = (state: IGlobalReducerState) => ({
    ...state.config,
});

const connector = connect(
    mapState,
);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(CamposApi);